<template>
  <b-dropdown class="speed-dropdown mx-lg-4" no-caret variant="btn">
    <template slot="button-content">
      <span>
        <i class="fa fa-2x fa-tachometer text-primary"></i>
      </span>
      <span class="text-size-normal mr-3 text-primary">
        {{ speed !== 1 ? speed + 'x' : '1x' }}
      </span>
    </template>
    <b-dropdown-header>{{ $t('speed') }}</b-dropdown-header>
    <b-dropdown-item :key="index" v-for="(s, index) in playbackSpeeds" class="text-center" :active="speed == s" @click="$emit('speed', s)">
      {{ s }}x
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: ['speed'],
  data() {
    return {
      playbackSpeeds: [0.75, 1, 1.25, 1.5, 1.75, 2],
    };
  },
};
</script>

<style>
</style>